/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const TRANSACTION_TYPES = {
  DEPOSIT: 1,
  CHARGE: 2,
}

export const STATUS_TYPES = {
  CANCELED: 1,
  PENDING: 2,
  COMPLETE: 3,
}
